// extracted by mini-css-extract-plugin
export var discard = "_27-4";
export var muiTooltipTooltip = "_27-6";
export var notificationBar = "_27-3";
export var notificationContainer = "_27-2";
export var saveButtonHoverSlotWrapper = "_27-5";
export var show = "_27-1";
export var spacer = "_27-0";